var render = function render(){var _vm=this,_c=_vm._self._c;return _c('figure',{directives:[{name:"lazyLoadImg",rawName:"v-lazyLoadImg"}],staticClass:"image__wrapper"},[_c('Spinner',{staticClass:"image__spinner"}),_c('img',{staticClass:"image__item",attrs:{"data-url":_vm.source,"alt":"random image"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }